export const GROUP_IDS = {
    KAPLAN: '59',
    SASC: '132',
    TEST_GROUP: '301',
    QEEENS_UNI_BELFAST: '37',
    SUTTON_TRUST: '2',
    THE: '40',
};

export const STR_UNIVERSITY_IDS = {
    CYCLOPES: '1474',
    VUW: '545',
    USYD: '528',
    TEST_UNI: '100061', // Staging test university (Man City)
    TEST_UNI_2: '103859', // Staging test university (Romans)
    TEST_UNI_3: '100722', // Production test university (Test University 3)
    TEST_UNI_4_PROD: '361', // Production test university (Test University 3)
    UNIVERSITY_OF_WORLD: '241', // University of the World
    NCUK: '80', // NCUK
    UNIVERSITY_OF_NICOSIA: '511', // University of Nicosia
};

export const UNIVERSITY_IDS = {
    CYCLOPES: 1474,
    TEST_UNI: 100061,
    TEST_UNI_2: 104759,
    TEST_UNI_3: 103859,
    INTAKE: 404,
    GRIFFITH: 161,
    UST_SYDNEY: 189,
    DOWNING: 388,
    DEAKIN: 896,
    SHEFELD_HALLAM: 1976,
    UNIVERSITY_OF_YORK: 1980,
};
